import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { AiOutlineTrophy } from 'react-icons/ai';
import moreMedal from 'src/app/images/more-medal.svg';
import { FiClipboard, FiEdit3, FiTarget, FiVideo } from 'react-icons/fi';
import { useQuery } from 'jsonapi-react';
import IconVerified from 'src/app/components/Icons/IconVerified';
import { CourseCard, CourseCardBody, CourseCardContent, CourseCardHeader, CourseCardImg, CourseCardImgWrapper, CourseCardInnerHeader, CourseCardNotifications, CourseCardSubtitle, CourseCardText, CourseCardTitle } from '@/components/custom/course';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CardProgressWrapper } from '@/components/ui/card';

export default function DashboardCourseCard(props) {
  const navigate = useNavigate();
  const { course, journey, setShowModal, setSelectedCourse } = props;
  const { data } = useQuery(`notifications?filter[courses.id]=${course.id}`);
  //TODO: Pedir ao backend para criar um filtro que retorne todas as notificacoes de cursos em uma única chamada para evitar chamada
  //em cada render deste componente.

  const handleClick = () => {
    setSelectedCourse(course);
    setShowModal(true);
  };

  const downloadCertificate = () => {
    window.open(`${process.env.REACT_APP_DEV_URL}//user_certificates/download/${course?.certificate?.hash_id}.pdf`, '_blank');
  };

  const amountClipboardNotifications = data?.filter(item => item.icon === 'FiClipboard' && item.unread).length;
  const amountEditNotifications = data?.filter(item => item.icon === 'FiEdit3' && item.unread).length;
  const amountTargetNotifications = data?.filter(item => item.icon === 'FiTarget' && item.unread).length;
  const amountVideoNotifications = data?.filter(item => item.icon === 'FiVideo' && item.unread).length;

  const courseProgress = course?.progress;

  return (
    <CourseCard
      onClick={() => {
        navigate(window.location.pathname === '/curso' || window.location.pathname === '/' ? `/curso/acompanhamento/${course?.id}` : handleClick());
      }}
    >
      <CourseCardBody alignment="home">
        <CourseCardImgWrapper>
          {/* <Badge size="xs">{course?.knowledge ? course?.knowledge : ''}</Badge> */}
          <CourseCardImg
            size="md"
            src={course?.image?.url}
            alt=""
          />
        </CourseCardImgWrapper>

        <CourseCardContent>
          <CourseCardHeader>
            <CourseCardInnerHeader>
              <div className="flex items-start gap-1.5">
                {course?.['official-content'] && <IconVerified />}
                <CourseCardTitle>{course?.title}</CourseCardTitle>
              </div>
              <CourseCardSubtitle>
                {course?.['finished-learning-system-items']}/{course?.['learning-system-item-count']} {t('dashboard.completedLessons')}
              </CourseCardSubtitle>
            </CourseCardInnerHeader>

            <CourseCardNotifications>
              {amountClipboardNotifications > 0 && (
                <div className="notification__icon notification__icon--sm notification__icon--warning">
                  <FiClipboard />
                  <span className="notifications__badge">{amountClipboardNotifications > 9 ? '+9' : amountClipboardNotifications}</span>
                </div>
              )}

              {amountEditNotifications > 0 && (
                <div className="notification__icon notification__icon--sm notification__icon--warning">
                  <FiEdit3 />
                  <span className="notifications__badge">{amountEditNotifications > 9 ? '+9' : amountEditNotifications}</span>
                </div>
              )}

              {amountTargetNotifications > 0 && (
                <div className="notification__icon notification__icon--sm notification__icon--warning">
                  <FiTarget />
                  <span className="notifications__badge">{amountTargetNotifications > 9 ? '+9' : amountTargetNotifications}</span>
                </div>
              )}

              {amountVideoNotifications > 0 && (
                <div className="notification__icon notification__icon--sm notification__icon--warning">
                  <FiVideo />
                  <span className="notifications__badge">{amountVideoNotifications > 9 ? '+9' : amountVideoNotifications}</span>
                </div>
              )}
            </CourseCardNotifications>

            {course?.progress === 100 && (
              <div className="medal medal--sm">
                <img
                  src={moreMedal}
                  alt="nova medalha"
                  className="medal__img"
                />
                <span className="medal__value">
                  <AiOutlineTrophy />
                </span>
              </div>
            )}
          </CourseCardHeader>

          <div>
            {course?.progress === 100 && !journey ? (
              <>
                <Badge
                  variant="success"
                  size="xs"
                >
                  Concluído
                </Badge>

                {/*{course?.certificate?.hash_id && (*/}
                {/*  <div>*/}
                {/*    <Button*/}
                {/*      variant="link"*/}
                {/*      className="px-0"*/}
                {/*      asChild*/}
                {/*    >*/}
                {/*      <a*/}
                {/*        onClick={e => {*/}
                {/*          e.stopPropagation();*/}
                {/*          downloadCertificate();*/}
                {/*        }}*/}
                {/*      >*/}
                {/*        {t('button.certification')}*/}
                {/*      </a>*/}
                {/*    </Button>*/}
                {/*  </div>*/}
                {/*)}*/}
              </>
            ) : (
              <CardProgressWrapper
                percentage={courseProgress}
                toFixed={0}
              />
            )}
          </div>
        </CourseCardContent>
      </CourseCardBody>
    </CourseCard>
  );
}
